module.exports = __webpack_public_path__ + "static/media/barkbliss-3.69bc345e.jpg";